import { jsx as _jsx } from "react/jsx-runtime";
import { useOutputsIcon } from 'z3k-settings/components/service/components/device-io-model/model/use-outputs-icon';
import { ColumnBox } from 'console/shared/components/containers';
export function DeviceIoModel({ io_ext_ids, device_name }) {
    const Component = useOutputsIcon(io_ext_ids, device_name);
    return (_jsx(ColumnBox, { pt: 4, pb: 2, children: Component }));
}
